/* eslint-disable eqeqeq */
/* eslint-disable class-methods-use-this */
import { withTranslation } from "next-i18next";
import Link from "next/link";
import PropTypes from "prop-types";
import { Component } from "react";
import styles from "./sitemap.module.scss";

const propTypes = {
  data: PropTypes.object.isRequired,
};

class Sitemap extends Component {
  renderT0(tier0: any, index: any) {
    const { data, t } = this.props;
    const { url, content } = tier0;
    const tier1s = data.tier1s.filter(
      (tier1: any) => tier1.content.tier0 == content.tier0,
    );
    const catMapT = (_: string) => t(_, { ns: "category-map" });

    return [
      <legend key={index}>

        <h3>

          <strong>

            <Link href={url}>

              {catMapT(content.tier0)}
            </Link>
          </strong>
        </h3>
      </legend>,
      <div key={index} className="row">
        {tier1s.map(this.renderT1.bind(this))}
      </div>,
    ];
  }

  renderT1(tier1: any, index: any) {
    const { url, content } = tier1;
    const { t } = this.props;
    const catMapT = (_: string) => t(_, { ns: "category-map" });

    return (
      <div key={index} className={`col-sm-4 ${styles.list_item} list-item`}>

        <Link href={url}>

          {catMapT(content.tier1)}
        </Link>
      </div>
    );
  }

  renderMakes() {
    const { data, t } = this.props;

    return (
      <div className="row">

        <div className="col-xs-12">

          <legend>

            <h3>

              <strong>{t("Shop By Vehicle")}</strong>
            </h3>
          </legend>
        </div>

        {data.makes.map(this.renderMake.bind(this))}
      </div>
    );
  }

  renderMake(make: any, index: any) {
    const { url, content } = make;

    return (
      <div key={index} className={`col-sm-4 ${styles.list_item}`}>

        <Link href={url}>

          {content.make}
        </Link>
      </div>
    );
  }

  renderBrands() {
    const { data, t } = this.props;

    const brands = data.brands.sort((a: any, b: any) => a.content.brand.localeCompare(b.content.brand));

    return (
      <div className="row">

        <div className="col-xs-12">

          <legend>

            <h3>

              <Link href="/find-original-oem-auto-parts-oem-manufacturers-and-oem-suppliers">
                <strong>{t("Shop By Brand")}</strong>
              </Link>
            </h3>
          </legend>
        </div>

        {brands.map(this.renderBrand.bind(this))}
      </div>
    );
  }

  renderBrand(brand: any, index: any) {
    const { url, content } = brand;

    return (
      <div key={index} className={`col-sm-4 ${styles.list_item}`}>

        <Link href={url}>

          {content.brand}
        </Link>
      </div>
    );
  }

  renderParts() {
    const { data, t } = this.props;

    const parts = data.products.sort((a: any, b: any) => a.content.product.localeCompare(b.content.product));

    return (
      <div className="row">

        <div className="col-xs-12">

          <legend>

            <h3>

              <Link href="/best-selling-auto-parts">

                <strong>{t("Shop By Parts")}</strong>
              </Link>
            </h3>
          </legend>
        </div>

        {parts.map(this.renderPart.bind(this))}
      </div>
    );
  }

  renderPart(part: any, index: any) {
    const { url, content } = part;
    const { t } = this.props;
    const catMapT = (_: string) => t(_, { ns: "category-map" });

    return (
      <div key={index} className={`col-sm-4 ${styles.list_item}`}>

        <Link href={url}>

          {catMapT(content.product)}
        </Link>
      </div>
    );
  }

  render() {
    const { data, t } = this.props;
    return (
      <div className={styles.sitemap}>

        <h1>

          <strong>{t("All Departments")}</strong>
        </h1>

        {data.tier0s.map(this.renderT0.bind(this))}

        {this.renderMakes()}
        {this.renderBrands()}
        {this.renderParts()}
      </div>
    );
  }
}

Sitemap.propTypes = propTypes;

export default withTranslation(["static-pages", "category-map"])(Sitemap);
